import { ShowTimerApi } from '../../generated/api';
import configuration from './configuration';

const showTimerService = new ShowTimerApi(configuration);

export default showTimerService;
